
import { Field, FieldProps, getIn } from "formik";
import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { ApiFieldAnswer, useRiskScoringFieldAnswerValuesQuery } from "../../../../../../store/models/risk";
import { Box, Chip, FormControl, TextField } from "@material-ui/core";
import Autocomplete, { AutocompleteRenderInputParams } from "@material-ui/lab/Autocomplete";

export interface RiskSelectFieldProps {
  disabled: boolean;
  label?: string;
  multiple?: boolean;
  onChange: (value: ApiFieldAnswer) => void;
  answerType: string;
}
export const RiskSelectField: FC<
  RiskSelectFieldProps & FieldProps<string[], string[]>
> = ({
  disabled = false,

  label,
  multiple = false,
  onChange = () => null,
  answerType,
  field,
  form: { values, touched, errors, handleBlur, handleChange, setFieldValue, submitForm },
  ...props
}) => {
    const { t } = useTranslation();

    const { data: answers } = useRiskScoringFieldAnswerValuesQuery(
      { answerType },
      { refetchOnMountOrArgChange: true },
    );

    useEffect(() => {
      if (getIn(values, field.name).length === 0 && answers !== undefined) {
        setFieldValue(field.name, [answers.find((e) => e.value === 'Unknown' || e.value === 'Unknown:')?.id!])
        submitForm();
      }

    }, [values, field, answers, setFieldValue, submitForm]);

    return (
      <>
        {/* <pre>{JSON.stringify(touched, null, 2)}</pre> */}
        {/* <pre>{JSON.stringify(errors, null, 2)}</pre> */}
        {/* <pre>{JSON.stringify(getIn(values, field.name), null, 2)}</pre> */}
        {/* <pre>{JSON.stringify(answers, null, 2)}</pre> */}
        {/* <pre>{JSON.stringify(answers?.find((e) => e.value === 'Unknown')?.id!, null, 2)}</pre> */}
        {answers && answers?.length > 0 && (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <FormControl variant="outlined" fullWidth margin="normal">
              <Field
                multiple={multiple}
                freeSolo
                component={Autocomplete}
                name={`${field.name}`}
                fullWidth
                value={
                  multiple
                    ? getIn(values, field.name)?.map((v: string) =>
                      answers.find((e) => e.id === v)?.id!
                    )
                    : getIn(values, field.name)
                }
                onBlur={handleBlur(`${field.name}`)}
                onChange={(e: any, value: any) => {
                  if (multiple) {
                    setFieldValue(`${field.name}`, value.map((v: any) => typeof v == 'string' ? v : v.id));
                  } else {
                    setFieldValue(`${field.name}`, value?.id ? [value.id] : []);
                  }
                  onChange(value);
                  submitForm();
                }}
                options={answers || []}
                autoHighlight
                variant="outlined"
                filterOptions={(
                  options: Array<ApiFieldAnswer>,
                  state: { inputValue: string }
                ): Array<ApiFieldAnswer> => {
                  return options.filter(
                    (x) =>
                      x.value
                        ?.toLowerCase()
                        ?.includes(state.inputValue.toLowerCase()) ||
                      x.id
                        ?.toLowerCase()
                        ?.includes(state.inputValue.toLowerCase())
                  );
                }}
                isOptionEqualToValue={(
                  option: ApiFieldAnswer,
                  value: ApiFieldAnswer | null
                ) => option.id === value?.id}
                getOptionLabel={(option: string[]) => {
                  return `${answers.find(x => x.id === option[0])?.value || ''}`
                }}
                renderOption={(option: ApiFieldAnswer) =>
                (
                  <Box key={option.id} component="li">
                    {option.value}
                  </Box>
                )
                }
                renderTags={(value: string[], getTagProps: any) =>
                  value.map((option: string, index: number) =>
                  (
                    <>
                      <Chip
                        variant="outlined"
                        label={answers.find((e) => e.id === option)?.value!}
                        {...getTagProps({ index })}
                      />
                    </>
                  )
                  )
                }
                renderInput={(params: AutocompleteRenderInputParams) => (
                  <>
                    <TextField
                      variant="outlined"
                      {...params}
                      size="small"
                      label={label}
                      error={Boolean(
                        getIn(touched, field.name) && !!getIn(errors, field.name)
                      )}
                      helperText={
                        getIn(touched, field.name) && t(getIn(errors, field.name))
                      }
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: "new-password",
                      }}
                      InputProps={{
                        ...params.InputProps,
                      }}
                    />
                  </>
                )}
              ></Field>
            </FormControl>
          </Box >
        )}
      </>
    );
  };
